module.exports = __webpack_public_path__ + "media/src/img/pechat-8d795ac6a20738b73ec1739204bff273.png";